module.exports = {"360822100":"文峰镇","360822101":"阜田镇","360822102":"盘谷镇","360822103":"枫江镇","360822104":"黄桥镇","360822105":"金滩镇","360822106":"八都镇","360822107":"双村镇","360822108":"醪桥镇","360822109":"螺田镇","360822110":"白沙镇","360822111":"白水镇","360822112":"丁江镇","360822113":"乌江镇","360822114":"水南镇","360822200":"尚贤乡","360822201":"水田乡","360822202":"冠山乡","360822400":"吉水县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360822.json
// module id = 1307
// module chunks = 0